module.exports = __webpack_public_path__ + "img/B.b7a982d8.png";